import { TitleComponent } from "ui-components";
import HeadCountChart from "../../components/common/graph/head-count";
import TeamProfile from "../../components/team-profile";
import { CompanyType, ManagementT } from "ui-io/company-io";
import { useMemo } from "react";
type Props = {
  currentCompany?: CompanyType;
};
const CompanyTeams = (props: Props) => {
  const { currentCompany } = props;

  const convertToBiannual = (records: any) => {
    const currentYear = new Date().getFullYear();
    if (records.length === 1) {
      const { count, year, _id } = records[0];
      const recordYear = parseInt(year, 10);
      const midpoint = Math.floor((count.from + count.to) / 2);

      if (recordYear === currentYear) {
        // **Ensure December 2024 comes first, then April 2025**
        return [
          {
            count: { from: count.from, to: midpoint },
            year: `${recordYear - 1} December`,
            _id,
          },
          {
            count: { from: count.from, to: count.to },
            year: `${recordYear} April`,
            _id,
          },
        ];
      } else {
        // **For past years, use June & December in the same year**
        return [
          {
            count: { from: count.from, to: midpoint },
            year: `${recordYear} June`,
            _id,
          },
          {
            count: { from: midpoint + 1, to: count.to },
            year: `${recordYear} December`,
            _id,
          },
        ];
      }
    }
    return records;
  };

  const [data, labels, funding, stage] = useMemo(() => {
    const data = [0];
    const labels: string[] = [];
    const funding = "$24M";
    const stage = "Early Stage VC (Series A)";

    if (currentCompany?.emp_count?.length) {
      let empCounts = currentCompany.emp_count;
      if (currentCompany?.emp_count?.length == 1) {
        empCounts = convertToBiannual(currentCompany.emp_count);
      }
      empCounts.map((empCount, index) => {
        let count = empCount.count.to;
        if (index == 0) {
          count = empCount.count.from;
        }
        data.push(count);
        labels.push(empCount.year);
      });
    }

    return [data, labels, funding, stage];
  }, [currentCompany?.emp_count]);

  return (
    <>
      <TitleComponent>Founders & CEO</TitleComponent>

      {currentCompany?.management && currentCompany.management?.length > 0
        ? currentCompany.management.map((management: ManagementT) => (
            <TeamProfile
              name={management.name}
              linkedin={management?.linkedin}
              position={management?.position}
              profileImage={management?.profileImage}
              emailId={management?.email}
            />
          ))
        : null}
      <div className="mt-xxlg">
        <TitleComponent>Team Growth</TitleComponent>

        <div className="mt-md">
          <HeadCountChart
            data={data}
            labels={labels}
            funding={funding}
            stage={stage}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyTeams;
